import type {DehydratedSkill} from '../rl-skill'
import type {Metadata} from './metadata'

export const fromOpenApiSkill = (
  // The type used here is just one of many places where this same skill type appears in session metadata
  {uspId}: NonNullable<Metadata<'ela_targeted_skills_practice'>['skill']>
): DehydratedSkill => ({uspId})
